import {
 all, call, put, select,
} from 'redux-saga/effects';
import queryString from 'query-string';
import { API } from '../../api';
import { DYNAMIC_FILTERS } from '../../configs/filter-types';

const getServerConfig = ({ serverConfig }) => serverConfig;

const getFilters = ({ filters }) => filters.reduce((acc, filter) => {
    if (filter.type === 'PARENT') {
      return [
        ...acc,
        ...(filter.filters || []).map((innerFilter) => ({
          ...innerFilter,
          source: filter.source,
        })),
      ];
    }

    acc.push(filter);
    return acc;
  }, []);

const getFetchingFilters = ({ fetchingFilters }) => fetchingFilters;

function* fetchFilter({
  type, key, source, options, unit, filterString,
}) {
  const serverConfig = yield select(getServerConfig);

  try {
    const query = {
      key: key.split('+')[0],
    };
    if (source) query.source = source;

    const path = `/filter/${
      serverConfig.namespace
    }/${type.toLowerCase()}?${queryString.stringify(query)}${
      filterString ? `&${filterString}` : ''
    }`;
    const result = yield call(API, 'get', 'api', path);

    if (result.key) {
      result.key = key;
    }

    result.unit = unit;

    if (options) {
      result.options = (result.options || []).map((option) => {
        const predefinedOption = options.find(
          ({ value }) => value === option.value,
        );
        if (predefinedOption) return predefinedOption;
        return option;
      });
    }

    return result;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  return null;
}

export function* fetchFilters() {
  const isFetchingFields = yield select(getFetchingFilters);
  if (isFetchingFields) {
    return;
  }
  yield put({ type: 'START_FETCHING_FILTERS' });
  const filters = yield select(getFilters);
  const filterResults = yield all(
    filters
      .filter(
        (filter) => DYNAMIC_FILTERS.includes(filter.type) && !filter.multikey,
      )
      .map((filter) => call(fetchFilter, filter)),
  );

  yield put({
    type: 'SET_FILTER_OPTIONS',
    payload: {
      filterResults,
    },
  });
  yield put({ type: 'STOP_FETCHING_FILTERS' });

  yield put({ type: 'STOP_REPORT_LOADING' });
}
